import { Div, GridCharts, useDragScroll } from '@vgrubs/components';
import { ReactNode } from 'react';

export const DragScrollX = ({
  children,
  width,
  widthMD,
  m,
  mSM,
  p,
  pSM,
  gap,
  gapSM,
}: {
  children: ReactNode;
  width?: string;
  widthMD?: string;
  m?: string;
  mSM?: string;
  p?: string;
  pSM?: string;
  gap?: string;
  gapSM?: string;
}) => {
  const { ref, onClickCapture, dragScrollStyle } = useDragScroll('x');

  return (
    <>
      <Div $tabletUp>
        <GridCharts
          tabIndex={-1}
          $width={width}
          ref={ref}
          onClickCapture={onClickCapture}
          style={dragScrollStyle}
          $m={m}
          $mSM={mSM}
          $p={p}
          $pSM={pSM}
          $gap={gap}
          $gapSM={gapSM}
        >
          {children}
        </GridCharts>
      </Div>
      <Div $tablet>
        <GridCharts
          tabIndex={-1}
          $width={widthMD}
          $m={m}
          $mSM={mSM}
          $p={p}
          $pSM={pSM}
          $gap={gap}
          $gapSM={gapSM}
        >
          {children}
        </GridCharts>
      </Div>
    </>
  );
};
